import { render, staticRenderFns } from "./PhysicalPersonDialog.vue?vue&type=template&id=738482a7&scoped=true&style=background%3A%20var(--v-muted-base)&"
import script from "./PhysicalPersonDialog.vue?vue&type=script&lang=js&"
export * from "./PhysicalPersonDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalPersonDialog.vue?vue&type=style&index=0&id=738482a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738482a7",
  null
  
)

export default component.exports